export const SUPPORTERS = 'supporters';
export const BIRTHDAYS = 'birthdays';
export const DISCOUNTS = 'discounts';
export const EVENTS = 'events';

export const SIDEBAR_WIDTH = 500;
